module.exports = __webpack_public_path__ + "img/certificate-upload.5bb6dc72.png";